/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from 'react'
import Icon, { CloseOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { AxiosResponse } from 'axios'
import { UploadChangeParam } from 'antd/lib/upload'
import { GoogleMap, Marker, Polygon, Polyline } from '@react-google-maps/api'
import {
  Button,
  Card,
  Col,
  Input,
  InputRef,
  List,
  Modal,
  Popconfirm,
  Progress,
  Row,
  Space,
  Upload,
} from 'antd'
import {
  faCheck,
  faCircleExclamation,
  faDownload,
  faFloppyDisk,
  faPen,
  faPenToSquare,
  faPlus as fasPlus,
  faSync,
  faTrash,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

// @ts-ignore
import { kml } from '@tmcw/togeojson'

//STYLES
import { ContainerMap } from '../../../../../../../Components/subArea/styled'

//ASSETS
import { IconAlert } from '../../../../../../../Components/iconsAlert'

//APP
import { TalhaoCultivaveisItens } from '../../../../../../../services/TalhaoSafra'
import { ItensPerUserLogged } from '../../../../../../../services/login/permissaoUsuarioLoado'
import {
  calculoAreaCoord,
  centerMap,
  customRequest,
  fileTypeText,
  getBoundsNoArray,
  parseXml,
  tryError,
} from '../../../../../../../services/Afins'
import {
  destroyAlert,
  errorAlert,
  loadingAlert,
  successAlert,
  warningAlert,
} from '../../../../../../../utils/alert'
import {
  delSubArea,
  postSubArea,
  putSubArea,
  TypeSubArea as SubAreaTypes,
} from '../../../../../../../services/subArea'
import { removerAcentos } from '../../../../../../../utils'

//COMPONENTS
import Icons from '../../../../../../../Components/Icons'
import { Notification } from '../../../../../../../Components/notification'
import DiasDesdeData from '../../../../../../../Components/DiasDesdeData'
import { Render } from '../../../../../../../Components/CustomUi/render'
import { geralKmlPolygon } from '../../../../../../../Components/gerarKml'
import Svg from '../../../../../../../Components/talhasvg'
import { PainelCard } from '../card'
import ButtonCustom from '../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Warning } from '../../../../../../../Components/CustomUi/warning'

interface TypesMapa {
  zoom: number
  center:
    | {
        lat: number
        lng: number
      }
    | google.maps.LatLng
  mapContainerStyle?: { [key: string]: string }
}

interface TypesSubArea {
  mapSet?: TypesMapa
  propriedade: number
  onClose: (data: boolean) => void
  listTalhoesRecord: TalhaoCultivaveisItens[]
  listTalhaoSafra: (data: number) => void
  update: number
  permissions: ItensPerUserLogged
  visible: boolean
 editIndexSubTalhao: number
 setEditIndexSubTalhao: React.Dispatch<React.SetStateAction<number>>
}

const SubArea: React.FC<TypesSubArea> = ({
  mapSet = {
    zoom: 2,
    center: {
      lat: 30.47664953933721,
      lng: -46.05009982090035,
    },
    mapContainerStyle: { width: '100%', height: '78vh' },
  },
  onClose,
  listTalhoesRecord,
  listTalhaoSafra,
  update,
  visible,
  permissions,
  editIndexSubTalhao,
  setEditIndexSubTalhao
}) => {
  const scrollTalhao = useRef<HTMLDivElement>()

  const url = useRef(null)

  const refInputNameSubTalhao = useRef<InputRef>()

  const listSubArea = useRef<HTMLDivElement>()

  const [flutuantDiv, setFlutuantDiv] = useState(false)
  const [recordInit, setRecordInit] = useState(false)

  const [map, setMap] = useState<google.maps.Map>()

  const [listTalhao, setListTalhao] = useState(listTalhoesRecord)

  const [postProgress, setPostProgress] = useState(0)

  const [talhaoSelect, setTalhaoSelect] = useState(0)

  const [indexTalhaoSelect, setIndexTalhaoSelect] = useState(0)

  const [namesExistente, setNamesExistente] = useState([])

  const [nameSubArea, setNameSubArea] = useState('')

  const [loadingSalvar, setLoadingSalvar] = useState(false)

  const [propsMap, setPropsMapa] = useState<TypesMapa>(mapSet)

  const [coord, setCoord] = useState([])
  const [stateSubArea, setStateSubArea] = useState([])
  const [linePolyline, setLinePolyline] = useState<google.maps.LatLng[]>([])

  const [polyline, setPolyline] = useState<google.maps.Polyline>()

  const [marker, setMarker] = useState<google.maps.LatLngLiteral[]>([])

  const [polySubTalhao, setPolySubTalhao] = useState([])

  const [recordMap, setRecordMap] = useState(false)
  const [logUser, setLogUser] = useState(false)
  const [usuarioQueCriou, setUsuarioQueCriou] = useState('')
  const [usuarioQueAlterou, setUsuarioQueAlterou] = useState('')
  const [dataCriacao, setDataCriacao] = useState('')
  const [horarioDeCriacao, setHorarioDeCriacao] = useState('')
  const [horarioDeAtualizacao, setHorarioDeAtualizacao] = useState('')
  const [dataAlteracao, setDataAlteracao] = useState('')
  const [diasDesdeCriacao, setDiasDesdeCriacao] = useState(null)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [modalNovaSubarea, setModalNovaSubarea] = useState<boolean>(false)
  const [modalAlerta, setModalAlerta] = useState<boolean>(false)
  const [polygonSubAreaNova, setPolygonSubAreaNova] = useState<google.maps.PolyMouseEvent>()
  const [dataSubArea, setDataSubArea] = useState()
  const [nome, setNome] = useState()

  const handleDataFromCreation = (dias) => {
    setDiasDesdeCriacao(dias)
  }

  const handleUnmountMap = () => {
    //
  }

  const handleClickHiddenFlutuant = (data: boolean) => {
    setFlutuantDiv(!data)
  }

  const handleClickPolygon = (data: google.maps.PolyMouseEvent) => {
    const lines = linePolyline
    const { latLng } = data

    const newPath = [...lines, latLng]

    setLinePolyline(newPath)
    setRecordInit(true)
  }

  const handleMouseUpPolyline = (data: google.maps.PolyMouseEvent, nome) => {
    let line = linePolyline
    const inicio = line[0].toJSON()
    const fim = data.latLng.toJSON()

    for (let i = 0; i < polySubTalhao.length; i += 1) {
      const info = polySubTalhao[i]

      if (info.nome === nome) {
        return true
      }
    }

    if (inicio.lat === fim.lat && inicio.lng === fim.lng) {
      line = [...line, data.latLng]

      let arqui = []
      for (let i = 0; i < line.length; i += 1) {
        const lin = line[i]
        arqui = [...arqui, lin.toJSON()]
      }

      const area = calculoAreaCoord([line])
      const kml = geralKmlPolygon(arqui, removerAcentos(nome))
      const cripto = btoa(kml)

      const arquivo = `data:@file/xml;base64,${cripto}`

      const newArea = {
        cod: null,
        cod_talhao: talhaoSelect,
        nome,
        area,
        arquivo,
        subArea: line,
      }

      onFinish([newArea])

      setPolySubTalhao([newArea, ...polySubTalhao])

      setLinePolyline([])
    }
    return false
  }

  const onFinish = async (data) => {
    try {
      loadingAlert({ msg: 'Salvando alteração', id: 'alteracao' })

      let resp = []
      let propriedade = 0
      const subTalhaoPoly = data

      for (let i = 0; i < subTalhaoPoly.length; i += 1) {
        const subTalhao = subTalhaoPoly[i]
        // setPostProgress(calcPocentagem(i + 1, subTalhaoPoly.length))

        const dados = {
          cod: subTalhao.cod,
          nome: subTalhao.nome,
          arquivo: subTalhao.arquivo,
          cod_talhao: subTalhao.cod_talhao,
          area: subTalhao.area,
        }

        if (subTalhao.cod === null) {
          const post: AxiosResponse<SubAreaTypes> = await postSubArea(dados)

          subTalhao.cod = post.data.itens[0].cod
          propriedade = post.data.itens[0].cod_propriedade

          resp = [...resp, post]
        } else {
          resp = [...resp, await putSubArea(dados.cod, dados)]
          propriedade = resp[0].data.itens[0].cod_propriedade
        }
      }

      destroyAlert('alteracao')
      setRecordInit(false)
      successAlert('Subárea salva com sucesso!')
      listTalhaoSafra(propriedade)
      return true
    } catch (error) {
      destroyAlert('alteracao')
      tryError(error)
    }
  }

  const calcPocentagem = (qtda, total) => {
    return parseFloat(((qtda * 100) / total).toFixed(2))
  }

  const handleCloseModal = () => {
    if (recordInit) {
      Modal.info({
        title: 'Existem dados que não foram salvos, deseja realmente cancelar?',
        icon: <Icon component={() => <Icons icon={faCircleExclamation} />} />,
        okText: 'Sim',
        cancelText: 'Não',
        okCancel: true,
        onOk: (close) => {
          update = 0
          setEditIndexSubTalhao(null)
          setPolySubTalhao([])
          setLinePolyline([])
          setRecordMap(false)
          setRecordInit(false)
          onClose(false)
          close()
        },
      })
    } else {
      update = 0
      setEditIndexSubTalhao(null)
      setPolySubTalhao([])
      setRecordMap(false)
      onClose(false)
    }
  }

  const handleEditSubarea = (data: any[]) => {
    let newArray = []
    for (let i = 0; i < data.length; i += 1) {
      const item = data[i]

      if (item?.kml) {
        const subArea = item

        let tempCoord = []
        let arqui = []
        for (let ii = 0; ii < subArea.kml.coordenadas.length; ii += 1) {
          const latlng = subArea.kml.coordenadas[ii]
          tempCoord = [
            ...tempCoord,
            new window.google.maps.LatLng({
              lat: latlng.latitude,
              lng: latlng.longitude,
            }),
          ]

          arqui = [
            ...arqui,
            {
              lat: latlng.latitude,
              lng: latlng.longitude,
            },
          ]
        }

        const kml = geralKmlPolygon(arqui, removerAcentos(subArea.nome))
        const cripto = btoa(kml)

        const arquivo = `data:@file/xml;base64,${cripto}`

        newArray = [
          ...newArray,
          {
            cod: subArea.cod,
            cod_talhao: subArea.cod_talhao,
            nome: subArea.nome,
            area: subArea.area,
            arquivo,
            subArea: tempCoord,
          },
        ]
      } else {
        newArray = data
      }
    }
    if (map) {
      map.fitBounds(getBoundsNoArray(newArray[0].subArea))
      setCoord(newArray[0].subArea)
    }
    return newArray
  }

  // const handleChangeNameSubArea = () => {
  //   const name = refInputNameSubTalhao.current.input.value

  //   setRecordInit(true)

  //   setNameSubArea(name)
  // }

  const handleClickListPolygon = (index, scroll: boolean, dados) => {
    setTalhaoSelect(dados[0].cod)
    setListTalhao(dados)
    setIndexTalhaoSelect(index)

    dados.forEach((data, i) => {
      if (i === index) {
        setPolySubTalhao([...handleEditSubarea(data.sub_area)])
      } else {
        setPolySubTalhao([])
      }
    })
    dados[0].kml.lookAt = {
      lat: dados[0].kml.lookAt.latitude,
      lng: dados[0].kml.lookAt.longitude,
    }

    let poly = []
    dados[0].kml.coordenadas.forEach((data) => {
      poly = [
        ...poly,
        {
          lat: data.latitude,
          lng: data.longitude,
        },
      ]

      return poly
    })

    const center = centerMap(poly)

    setPropsMapa({
      zoom: 15,
      center,
    })
    setCoord(poly)
  }

  const handleClickNomeSubTalhao = (data: google.maps.PolyMouseEvent) => {
    const line = linePolyline
    const inicio = line[0].toJSON()
    const fim = data.latLng.toJSON()
    const final = data.latLng

    if (inicio.lat === fim.lat && inicio.lng === fim.lng) {
      line.push(final)
      if (checkCoord(line, true) <= 0) {
        // Modal.confirm({
        //   title: 'Nome da subárea',
        //   content: <Input required id='id_name_talhao' />,
        //   okText: 'Salvar',
        //   cancelText: 'Cancelar',
        //   cancelButtonProps: {
        //     type: 'primary',
        //     danger: true,
        //   },
        //   onOk: (close) => {
        //     // @ts-ignore
        //     const { value } = document.getElementById('id_name_talhao')
        //   },
        // })
        setPolygonSubAreaNova(data)
        setModalNovaSubarea(true)
      }
    } else {
      setLinePolyline(polyline.getPath().getArray())
    }
  }

  function salvarNovaSubArea() {
    if (nameSubArea.length <= 0) {
      errorAlert('Nome de subárea inválido!')
      return <></>
    }
    setRecordInit(true)
    if (handleMouseUpPolyline(polygonSubAreaNova, nameSubArea)) {
      errorAlert('Nome da subárea já cadastrado')
    } else {
      setRecordMap(false)
      setRecordInit(true)
      setModalNovaSubarea(false)
      close()
    }
  }

  const handleMouseUpEditSubArea = (
    poly: google.maps.Polygon,
    e: google.maps.MouseEvent,
    index
  ) => {
    const dataPoly = [...polySubTalhao]
    const coord = poly.getPath().getArray()
    const inicial = dataPoly[index].subArea

    const newCoord = coord.map((data) => {
      const latlng = { lat: data.lat(), lng: data.lng() }
      return latlng
    })

    if (poly) {
      const path = poly.getPath()
      const v_index = coord.findIndex((latlng) => latlng.equals(e.latLng))
      if (v_index > -1) {
        path.removeAt(v_index)
      }
    }

    if (checkCoord([e.latLng]) > 0) {
      // destroyAlert();
      warningAlert('Ponto fora do talhão')

      poly.setPath(inicial)
      setPolySubTalhao(dataPoly)
    } else {
      const kml = geralKmlPolygon(newCoord, removerAcentos(dataPoly[index].nome))
      const cripto = btoa(kml)

      const arquivo = `data:@file/xml;base64,${cripto}`

      dataPoly[index].area = calculoAreaCoord([coord])
      dataPoly[index].subArea = coord
      dataPoly[index].arquivo = arquivo
      setRecordInit(true)

      setPolySubTalhao(dataPoly)
    }
  }

  const handleClickPenSupArea = (data, nome) => {
    if (linePolyline.length <= 0) {
      setRecordMap(false)
    }
    if (recordInit || linePolyline.length > 0) {
      // Modal.warning({
      //   title: 'Existe dados que não foram salvos deseja continuar?',
      //   okText: 'Sim',
      //   cancelText: 'Não',
      //   okCancel: true,
      //   onOk: () => {
      //     setEditIndexSubTalhao(data)
      //     setNameSubArea(nome)
      //     setRecordInit(false)
      //     setRecordMap(false)
      //     setLinePolyline([])
      //   },
      // })
      setModalAlerta(true)
    } else {
      setEditIndexSubTalhao(data)
      setNameSubArea(nome)
    }
  }

  function mostrarAlerta() {
    setEditIndexSubTalhao(dataSubArea)
    setNameSubArea(nome)
    setRecordInit(false)
    setRecordMap(false)
    setModalAlerta(false)
    setLinePolyline([])
  }

  const handleClickSaveEditSupArea = (index) => {
    setEditIndexSubTalhao(null)
    const poly = [...polySubTalhao]
    const newName = nameSubArea

    poly[index].nome = newName

    onFinish([poly[index]])
    setPolySubTalhao(poly)
  }

  const handleEditPolyline = () => {
    setRecordInit(true)
  }

  const handleNewSubTalhao = () => {
    setRecordMap(!recordMap)
    setLinePolyline(recordMap ? [] : linePolyline)

    setEditIndexSubTalhao(null)
  }

  const handleBaixarKml = (dados, nome) => {
    try {
      url.current.href = dados
      url.current.download = `${nome}.kml`
      url.current.click()
    } catch (error) {
    }
  }

  const handleTrashSubArea = async (index) => {
    const poly = [...polySubTalhao]
    const list = [...listTalhao]
    setFake_loading(true)
    try {
      if (poly[index].cod !== null) {
        loadingAlert({ msg: 'Removendo...', id: 'remove_subarea' })
        const resp: AxiosResponse<SubAreaTypes> = await delSubArea(poly[index].cod)

        if (resp.status === 200) {
          const temp = poly.filter((data, i) => i !== index)
          setPolySubTalhao(temp)

          list[indexTalhaoSelect].sub_area = temp

          setListTalhao(list)

          listTalhaoSafra(resp.data.itens[0].cod_propriedade)
          successAlert('Subárea removida com sucesso!', 5000, 'remove_subarea')
          setEditIndexSubTalhao(null)
          setFake_loading(false)
          setConfirmar_exclusao(false)
        }
      } else {
        poly.splice(index, 1)
        setPolySubTalhao(poly)
        setFake_loading(false)
        setConfirmar_exclusao(false)
      }
    } catch (error) {
      errorAlert(error?.message ?? 'Falha na operação!', 7000, 'remove_subarea')
      setFake_loading(false)
    }
  }

  const onLoadPolyline = (data: google.maps.Polyline) => {
    setPolyline(data)
  }

  const onChange = (e, i) => {
    const dados = [...namesExistente]
    const { value } = e.target
    dados[i].nome = value

    setNamesExistente(dados)
  }

  const onChangeUpload = async (info: UploadChangeParam) => {
    try {
      loadingAlert({ msg: 'Importando...', id: 'import' })
      if (info.file.status === 'done') {
        const domKml = parseXml(await fileTypeText(info.file.originFileObj))

        const dataGeoJson = kml(domKml)
        let tempTalhao = []
        let fileInvalid = []
        let contem = []
        let nameExiste = []
        let names = []

        setNamesExistente([])
        for (let i = 0; i < dataGeoJson.features.length; i += 1) {
          const listKml = dataGeoJson.features[i]
          if (listKml.geometry.type === 'Polygon') {
            let tempCoord = []
            for (let ii = 0; ii < listKml.geometry.coordinates[0].length; ii += 1) {
              const latlng = listKml.geometry.coordinates[0][ii]
              tempCoord = [
                ...tempCoord,
                new window.google.maps.LatLng({
                  lat: latlng[1],
                  lng: latlng[0],
                }),
              ]
            }

            let arq = []
            let checkCo = []
            for (let ii = 0; ii < tempCoord.length; ii += 1) {
              const coord: google.maps.LatLng = tempCoord[ii]
              arq = [...arq, coord.toJSON()]
              checkCo = [...checkCo, coord]
            }
            names = [...names, arq]
            const check = checkCoord(checkCo)

            if (check > 0) {
              Notification({
                message: 'Subáreas não importadas por estarem fora do talhão',
                type: 'error',
                placement: 'bottom',
                descricao: (
                  <>
                    {names.map((data) => (
                      <Icon key='' component={() => <Svg fill='red' coordinates={data} />} />
                    ))}
                  </>
                ),
              })
            } else {
              const area = calculoAreaCoord([tempCoord])

              let name = ''
              if (listKml.properties.NOME) {
                name = removerAcentos(listKml.properties.NOME)
              } else if (listKml.properties.name) {
                name = removerAcentos(listKml.properties.name)
              } else if (listKml.properties.nome) {
                name = removerAcentos(listKml.properties.nome)
              } else {
                name = 'Nome nao localizado'
              }
              const dados = polySubTalhao
              contem = dados.filter((record) => record.nome === name)

              if (contem.length > 0) {
                //
                const kml = geralKmlPolygon(arq, removerAcentos(name))

                const cripto = btoa(kml)

                const arquivo = `data:@file/xml;base64,${cripto}`

                nameExiste = [
                  ...nameExiste,
                  {
                    cod: null,
                    cod_talhao: talhaoSelect,
                    nome: name,
                    area,
                    arquivo,
                    subArea: tempCoord,
                  },
                ]
              } else {
                /**a dunção removerAcentos irá remover acentos e caracteres especiais. Porém ao tratar o nome do talhão "TH Apeú" estrá transformando em "TH APEAs"
                 * por isso criei essa gambiarra apenas para tratar esse nome.
                 * nos demais irá funcionar normalmente
                 */
                let excecao_faz_apeu = removerAcentos(name)?.replace('APEAs', 'APEU')
                const kml = geralKmlPolygon(arq, excecao_faz_apeu)

                const cripto = btoa(kml)

                const arquivo = `data:@file/xml;base64,${cripto}`

                tempTalhao = [
                  ...tempTalhao,
                  {
                    cod: null,
                    cod_talhao: talhaoSelect,
                    nome: name,
                    area,
                    arquivo,
                    subArea: tempCoord,
                  },
                ]
              }
            }
          } else {
            fileInvalid = [
              ...fileInvalid,
              {
                nome: listKml.properties.name || listKml.properties.NOME,
                type: listKml.geometry.type,
              },
            ]
          }
        }

        setNamesExistente(nameExiste)

        if (fileInvalid.length > 0) {
          Modal.warning({
            title: 'Arquivo contém dados inválidos',
            icon: <Icon component={() => <Icons icon={faWarning} />} />,
            content: (
              <>{`${fileInvalid.length}`} dados inválidos, o tipo de kml tem que ser Polygon</>
            ),
          })
        }
        if (tempTalhao.length > 0) {
          onFinish(tempTalhao)
        }

        setPolySubTalhao([...polySubTalhao, ...tempTalhao])

        destroyAlert('import')
      }
    } catch (error) {
      tryError(error)
    }
  }

  function fecharCard() {
    setPolySubTalhao([])
    setNameSubArea('')
    setRecordMap(false)
  }

  const checkCoord = (latLng: google.maps.LatLng[], f = false) => {
    const dados = listTalhao[0].kml.coordenadas
    let tempCoord: google.maps.LatLng[] = []
    if (f) {
      tempCoord = latLng
    } else {
      for (let i = 0; i < dados.length; i += 1) {
        const list = dados[i]
        tempCoord = [
          ...tempCoord,
          new google.maps.LatLng({ lat: list.latitude, lng: list.longitude }),
        ]
      }
    }

    const polygono = new google.maps.Polygon({ paths: tempCoord })
    let result = []
    let fora = []
    for (let i = 0; i < latLng.length; i += 1) {
      const coord = latLng[i]
      const resultPath = google.maps.geometry.poly.containsLocation(coord, polygono)

      if (!resultPath) {
        result = [...result, resultPath]
        fora = [...fora, { lat: coord.lat(), lng: coord.lng() }]
      }
    }

    setMarker(fora)
    return result.length
  }

  useEffect(() => {
    try {
      const dados = [...listTalhoesRecord]

      let index = 0
      const filter = dados.filter((data, i) => {
        if (data.cod === update) {
          index = i
        }

        return data.cod === update
      })

      handleClickListPolygon(index, true, filter)

      setListTalhao(filter)
    } catch (error) {
      tryError(error)
    }
  }, [listTalhoesRecord])

  useEffect(() => {
    handleEditSubarea(listTalhao)
  }, [listTalhao])

  useEffect(() => {
    if (visible) {
      const subCheck = listTalhao.map((item) => item.sub_area)

      if (subCheck.length > 0) {
        if (subCheck[0][0] && subCheck[0][0].create_user !== undefined) {
          setUsuarioQueCriou(subCheck[0][0]?.create_user)

          const dateOnlyString = subCheck[0][0]?.create_time?.split(' ')[0]
          const timeOnlyString = subCheck[0][0]?.create_time?.split(' ')[1]

          setDataCriacao(dateOnlyString)
          setHorarioDeCriacao(timeOnlyString)
          setLogUser(true)
        } else {
          setLogUser(false)
        }

        if (subCheck[0][0] && subCheck[0][0].update_user !== undefined) {
          setUsuarioQueAlterou(subCheck[0][0]?.update_user)

          const dateOnlyString = subCheck[0][0]?.update_time?.split(' ')[0]
          const timeOnlyString = subCheck[0][0]?.update_time?.split(' ')[1]

          setDataAlteracao(dateOnlyString)
          setHorarioDeAtualizacao(timeOnlyString)
          setLogUser(true)
        } else {
          setLogUser(false)
        }
      }
    } else {
      setUsuarioQueCriou('')
      setUsuarioQueAlterou('')
    }

    if (update === 0) {
      setLogUser(false)
    }
  }, [
    logUser,
    listTalhao,
    usuarioQueAlterou,
    usuarioQueCriou,
    visible,
    update,
    horarioDeAtualizacao,
    horarioDeCriacao,
  ])

  return (
    <Col span={24}>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          {/* @ts-ignore */}
          <GoogleMap
            onUnmount={handleUnmountMap}
            onLoad={setMap}
            options={{
              streetViewControl: false,
              zoomControl: false,
              mapTypeId: 'hybrid',
              mapTypeControl: false,
              fullscreenControl: false,
              draggable: true,
            }}
            zoom={propsMap.zoom}
            mapContainerStyle={{
              width: '100%',
              height: '100vh',
            }}
          >
            <Polygon
              path={coord}
              onClick={handleClickPolygon}
              options={{
                clickable: recordMap,
                strokeColor: recordMap ? 'orange' : 'white',
                fillColor: 'white',
                fillOpacity: 0.3,
                strokeWeight: 4,
                geodesic: false,
              }}
            />
            {/* {marker.map((rec) => (
              // @ts-ignore
              <Marker position={{ ...rec }} />
            ))} */}
            <Polyline
              onMouseUp={handleClickNomeSubTalhao}
              onMouseDown={handleEditPolyline}
              onLoad={onLoadPolyline}
              editable
              draggable
              options={{
                strokeColor: 'cyan',
              }}
              path={linePolyline}
            />

            {polySubTalhao.map((data, index) => {
              return (
                <Polygon
                  key={data.cod}
                  path={data.subArea}
                  onLoad={(poly) => {
                    data.polygon = poly
                    return <></>
                  }}
                  onMouseUp={(e) => handleMouseUpEditSubArea(data.polygon, e, index)}
                  options={{
                    editable: editIndexSubTalhao === index,
                    clickable: recordMap,
                    fillColor: editIndexSubTalhao === index ? 'orange' : 'cyan',
                    fillOpacity: 0.3,
                    strokeColor: editIndexSubTalhao === index ? 'orange' : 'cyan',
                    strokeWeight: 3,
                    geodesic: false,
                  }}
                />
              )
            })}
          </GoogleMap>
        </Col>
        <PainelCard
          onClose={onClose}
          dadosSubArea={polySubTalhao}
          dadosTalhao={listTalhoesRecord}
          excluir_subarea={handleTrashSubArea}
          baixarKmlSubarea={handleBaixarKml}
          editarSubArea={handleClickPenSupArea}
          salvarEditar={handleClickSaveEditSupArea}
          importarSubarea={onChangeUpload}
          novaSubArea={handleNewSubTalhao}
          editIndexSubTalhao={editIndexSubTalhao}
          nome={nameSubArea}
          setNome={setNameSubArea}
          urlRef={url}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          talhaoSelect={talhaoSelect}
          recordMap={recordMap}
          loadingSalvar={loadingSalvar}
          fecharCard={fecharCard}
        />
      </Row>

      <Modal
        title=''
        footer={false}
        closeIcon={false}
        closable={false}
        width='387px'
        style={{ top: '100px', gap: 10 }}
        open={modalAlerta}
        onCancel={() => setModalAlerta(false)}
        className='modal__subarea'
      >
        <div>
          <Warning type='warning'>
            Existe dados que não foram salvos deseja continuar?
          </Warning>
        </div>
        <div style={{ marginTop: 10, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <ButtonCustom
            onClick={() => setModalAlerta(false)}
            icon={<FontAwesomeIcon icon={faXmark} />}
            danger
            type='secondary'
          >
            Não
          </ButtonCustom>
          <ButtonCustom onClick={mostrarAlerta} icon={<FontAwesomeIcon icon={faFloppyDisk} />}>
            Sim
          </ButtonCustom>
        </div>
      </Modal>
      <Modal
        title=''
        footer={false}
        closeIcon={false}
        closable={false}
        width='387px'
        style={{ top: '100px', gap: 10 }}
        open={modalNovaSubarea}
        onCancel={() => setModalNovaSubarea(false)}
        className='modal__subarea'
      >
        <div>
          <label style={{ fontSize: '13px', fontWeight: '600' }}>Nova subárea</label>
          <Input
            value={nameSubArea}
            onChange={(e) => setNameSubArea(e.target.value)}
            placeholder='Digite o nome da subárea'
          />
        </div>
        <div style={{ marginTop: 10, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <ButtonCustom
            onClick={() => setModalNovaSubarea(false)}
            icon={<FontAwesomeIcon icon={faXmark} />}
            danger
            type='secondary'
          >
           Fechar
          </ButtonCustom>
          <ButtonCustom onClick={salvarNovaSubArea} icon={<FontAwesomeIcon icon={faFloppyDisk} />}>
            Salvar
          </ButtonCustom>
        </div>
      </Modal>
      <Modal
        open={namesExistente.length > 0}
        onCancel={() => setNamesExistente([])}
        cancelText='Fechar'
        width={390}
        okButtonProps={{ hidden: true }}
        title={
          namesExistente.length <= 1 ? 'Nome da subárea já existe' : 'Subáreas com nome duplicado'
        }
      >
        <List size='small'>
          {namesExistente.map((info, index) => {
            let tempArea = []

            info.subArea.forEach((data) => {
              tempArea = [
                ...tempArea,
                {
                  lng: data.lng(),
                  lat: data.lat(),
                },
              ]

              return tempArea
            })
            return (
              <List.Item>
                <Space>
                  <Icon
                    component={() => (
                      // @ts-ignore
                      <Svg fill='green' coordinates={tempArea} />
                    )}
                  />

                  <Input
                    value={info.nome}
                    onChange={(e) => onChange(e, index)}
                    placeholder='Nome subárea'
                  />
                  <Button
                    type='primary'
                    onClick={() => {
                      const check = polySubTalhao.find((record) => record.nome === info.nome)

                      if (!check) {
                        if (checkCoord(info.subArea) > 0) {
                          warningAlert('Subáreas não importadas por estarem fora do talhão!')
                        } else {
                          const success = onFinish([info])
                          if (success) {
                            const dados = [...namesExistente]
                            dados.splice(index, 1)
                            setNamesExistente(dados)

                            setPolySubTalhao([...polySubTalhao, info])
                          }
                        }
                      } else {
                        errorAlert('Nome da subárea já existe')
                      }
                    }}
                  >
                    Salvar
                  </Button>
                </Space>
              </List.Item>
            )
          })}
        </List>
      </Modal>
    </Col>
  )
}

export default SubArea